const nextupStore = {
  state: {
    nextupData: {},
  },
  mutations: {
    SET_NEXTUP(state, payload) {
        state.nextupData =  payload
      },
  },
  actions: {
    
  },
};

export default nextupStore;